type ColorBase = 'blue' | 'green' | 'orange' | 'purple' | 'red'
type TipoClase = 'bg' | 'text' | 'border' | 'bg-light' | 'hover-bg'

export const obtenerColorClase = (color: ColorBase, tipo: TipoClase = 'bg'): string => {
  const colores: Record<ColorBase, Record<TipoClase, string>> = {
    blue: {
      bg: 'bg-blue-500 dark:bg-blue-600',
      'bg-light': 'bg-blue-100 dark:bg-blue-900/20',
      'hover-bg': 'hover:bg-blue-50 dark:hover:bg-blue-900/20',
      text: 'text-blue-600 dark:text-blue-400',
      border: 'border-blue-200 dark:border-blue-700',
    },
    green: {
      bg: 'bg-green-500 dark:bg-green-600',
      'bg-light': 'bg-green-100 dark:bg-green-900/20',
      'hover-bg': 'hover:bg-green-50 dark:hover:bg-green-900/20',
      text: 'text-green-600 dark:text-green-400',
      border: 'border-green-200 dark:border-green-700',
    },
    orange: {
      bg: 'bg-orange-500 dark:bg-orange-600',
      'bg-light': 'bg-orange-100 dark:bg-orange-900/20',
      'hover-bg': 'hover:bg-orange-50 dark:hover:bg-orange-900/20',
      text: 'text-orange-600 dark:text-orange-400',
      border: 'border-orange-200 dark:border-orange-700',
    },
    purple: {
      bg: 'bg-purple-500 dark:bg-purple-600',
      'bg-light': 'bg-purple-100 dark:bg-purple-900/20',
      'hover-bg': 'hover:bg-purple-50 dark:hover:bg-purple-900/20',
      text: 'text-purple-600 dark:text-purple-400',
      border: 'border-purple-200 dark:border-purple-700',
    },
    red: {
      bg: 'bg-red-500 dark:bg-red-600',
      'bg-light': 'bg-red-100 dark:bg-red-900/20',
      'hover-bg': 'hover:bg-red-50 dark:hover:bg-red-900/20',
      text: 'text-red-600 dark:text-red-400',
      border: 'border-red-200 dark:border-red-700',
    },
  }

  return colores[color]?.[tipo] || colores.blue[tipo]
}